import { PeriodMode } from '../enums/periodMode'
import { PeriodValue } from '../types/periodValue'

export const getPeriodValueFromFiscalYear = (fiscalYear: number): PeriodValue => ({
  mode: PeriodMode.FiscalYear,
  value: fiscalYear,
  year: fiscalYear,
})
